import React, { useState, useEffect } from 'react';
import { SelectFieldComponent } from '../common/SelectFieldComponent';
import { CatalogService } from '../../services/catalogService';
import { type Encargado } from '../../types/catalog';

interface EncargadoSelectProps {
  value: number | string;
  onChange: (value: number) => void;
  label?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const EncargadoSelect: React.FC<EncargadoSelectProps> = ({
  value,
  onChange,
  label = 'Encargado',
  error,
  required = false,
  disabled = false,
  fullWidth = true,
}) => {
  const [encargados, setEncargados] = useState<Encargado[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEncargados();
  }, []);

  const loadEncargados = async () => {
    try {
      setLoading(true);
      const data = await CatalogService.getEncargados();
      setEncargados(data);
    } catch (error) {
      console.error('Error loading encargados:', error);
    } finally {
      setLoading(false);
    }
  };

  const options = encargados.map(encargado => ({
    value: encargado.id,
    label: `${encargado.nombres} ${encargado.apellidos}`,
  }));

  return (
    <SelectFieldComponent
      label={label}
      value={value}
      onChange={(val) => onChange(Number(val))}
      options={options}
      error={error}
      required={required}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      placeholder={loading ? 'Cargando...' : 'Seleccione un encargado'}
    />
  );
};
